import './app.scss';
/* colorbox */
import './colorbox/colorbox.css';
//JS
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'jquery-colorbox';
import objectFitImages from 'object-fit-images';
objectFitImages('.obj-fit');


import { library, dom } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/free-brands-svg-icons";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons/faNewspaper";
import { faSliders } from "@fortawesome/free-solid-svg-icons/faSliders";
import { faBuilding } from "@fortawesome/free-solid-svg-icons/faBuilding";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons/faCircleUser";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons/faLocationDot";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faFilm } from "@fortawesome/free-solid-svg-icons/faFilm";
import { faComment } from "@fortawesome/free-solid-svg-icons/faComment";
import { faFacebook} from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faFacebookF} from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faInstagram} from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faSquareXTwitter} from "@fortawesome/free-brands-svg-icons/faSquareXTwitter";
import { faTiktok} from "@fortawesome/free-brands-svg-icons/faTiktok";
import { faTwitter} from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import { faAnglesUp } from "@fortawesome/free-solid-svg-icons/faAnglesUp";
import { faAnglesLeft } from "@fortawesome/free-solid-svg-icons/faAnglesLeft";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons/faAnglesRight";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";



library.add(faMagnifyingGlass,faAnglesUp,faAnglesLeft,faAnglesRight,faChevronLeft,faChevronRight,faTiktok,faNewspaper,faSliders,faBuilding,faCircleUser,faComments,faLocationDot,faUsers,faFilm,faComment,faFacebook,faFacebookF,faInstagram,faSquareXTwitter,faTwitter,faBars,faXmark);
dom.watch();